/**
 * The count-freshness predicate shared by every surface that gates on it: a `saved` promotion
 * (`services/audience.ts`), the audience-edit MCP's `get_audience` tool (`mcp/audience-edit.ts`), and
 * the audience-chat context envelope (`rpc/procedures/audience-chat.ts`). Pure predicate, no deps — a
 * single source of truth so the three copies can never silently diverge and read a stale count as fresh.
 *
 * A count is fresh only when it was actually recorded (`lastCountedAt` set) AND it was recorded for
 * EXACTLY the current definition hash — an edit after the last count invalidates it even though the
 * row still carries the old numbers.
 */
export function isCountFresh(
  lastCountedAt: string | null,
  lastCountDefinitionHash: string | null,
  currentDefinitionHash: string,
): boolean {
  return lastCountedAt != null && lastCountDefinitionHash === currentDefinitionHash;
}
